<nz-layout>
  <!-- 顶部 -->
  <nz-header>
    <div class="header-content">
      <div class="title-wrapper">
        <span class="main-title" (click)="reload()">MJ AI绘画</span>
        <div class="subtitle-box">
          <span class="sub-title typing-loop">· AI让绘画如此简单</span>
        </div>
      </div>

      <div class="button-group">
        <button nz-button nzGhost nzType="default" (click)="getMjDrawingList()">全部创作</button>
        <button nz-button nzGhost nzType="default" (click)="reset()">重置</button>
        <button nz-button nzGhost nzType="default" (click)="handleBack()">返回</button>
      </div>
    </div>
  </nz-header>
  <!-- 中间 -->
  <nz-layout>
    <!-- 左 侧边栏 -->
    <nz-sider [nzBreakpoint]="'lg'" [nzCollapsedWidth]="0" nzCollapsible class="sidebar">
      <div>
        <ul>
          <li [ngClass]="{'active': activeLink === 'home'}" (click)="setActiveLink('home')">首页</li>
          <li>更多功能正在开发中...</li>
          <!-- <li [ngClass]="{'active': activeLink === 'aiImage'}" (click)="setActiveLink('aiImage')">AI生图</li>
                    <li [ngClass]="{'active': activeLink === 'aiEdit'}" (click)="setActiveLink('aiEdit')">AI修图</li>
                    <li [ngClass]="{'active': activeLink === 'aiUse'}" (click)="setActiveLink('aiUse')">AI应用 (10+)</li> -->
          <!-- <ul class="submenu">
                        <li [ngClass]="{'active': activeLink === 'generatedVideo'}"
                            (click)="setActiveLink('generatedVideo')">#生成视频</li>
                        <li [ngClass]="{'active': activeLink === 'localDrawing'}"
                            (click)="setActiveLink('localDrawing')">#局部重绘</li>
                        <li [ngClass]="{'active': activeLink === 'watermark'}" (click)="setActiveLink('watermark')">
                            #水印/元素移除</li>
                        <li [ngClass]="{'active': activeLink === 'expandImage'}" (click)="setActiveLink('expandImage')">
                            #扩展图层</li>
                        <li [ngClass]="{'active': activeLink === 'modelChange'}" (click)="setActiveLink('modelChange')">
                            #模型转换</li>
                        <li [ngClass]="{'active': activeLink === 'personalPhoto'}"
                            (click)="setActiveLink('personalPhoto')">#个人照片</li>
                        <li [ngClass]="{'active': activeLink === 'portraitChange'}"
                            (click)="setActiveLink('portraitChange')">#单人换脸</li>
                        <li [ngClass]="{'active': activeLink === 'characterStyle'}"
                            (click)="setActiveLink('characterStyle')">#人物换风格</li>
                        <li [ngClass]="{'active': activeLink === 'productBackground'}"
                            (click)="setActiveLink('productBackground')">#产品换背景</li>
                        <li [ngClass]="{'active': activeLink === 'imageTransfer'}"
                            (click)="setActiveLink('imageTransfer')">#图片转线条</li>
                        <li [ngClass]="{'active': activeLink === 'generatedSimilars'}"
                            (click)="setActiveLink('generatedSimilars')">#生成相似图</li>
                    </ul> -->
        </ul>
      </div>
    </nz-sider>

    <!-- 右 -->
    <nz-content style="position:relative;">
      <div nz-row [nzGutter]="[30, 30]">
        <!-- 左侧套餐信息 -->
        <div nz-col nzXs="16" nzSm="14" nzMd="12" nzLg="14" nzXl="6" class="conent_top" nzOffset="1">
          <div class="img">
            <div class="fleet-top">
              <div class="fleet-left">
                <app-image [fileid]="seat?.valid_period?.icon" width="58px" height="58px"></app-image>
              </div>
              <div class="fleet-middle">
                <div class="fleet-title">{{ seat?.valid_period?.platform }}</div>
                <!-- <div class="fleet-subtitle">标准车队套餐月付</div> -->
              </div>
            </div>
            <div class="fleet-down">
              <div class="limit">
                <div class="limitDate">到期时间：<app-date [text]="seat?.valid_period?.ended_time"></app-date></div>
                <div class="limitFast">fast模式剩余：<span>{{statistics?.fast?.remaining}}</span> 次</div>
              </div>
              <div class="limit">
                <div class="limitDuration">剩余时长：{{seat?.valid_period?.remaining_days}}天</div>
                <div class="limitRelax">relax模式剩余：<span>{{statistics?.relax?.remaining}}</span> 次</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 右 -->
        <div nz-col nzXs="8" nzSm="10" nzMd="12" nzLg="10" nzXl="15" class="conent_top">
          <div class="intro">
            <h1>欢迎来到MJ AI绘画世界</h1>
            <h4>1.请在底部输入指令后，点击[绘画]，开始您真正的第一幅AI作品，您绘制的作品仅自己可见</h4>
            <h4 style="margin-top:20px;">2.如果您第一幅画不知道怎么画，请看：<span (click)="showSteps()" style="font-size: 20px;color: #DEABFF;text-decoration: underline;cursor: pointer;">怎么撰写提示词</span></h4>
          </div>
        </div>
      </div>
      <p>
      <p>
        <!-- 生成内容 -->
      <div nz-row style="margin-top: 50px">
        <div nz-col nzSpan="16" nzOffset="4" class="mj-content" *ngFor="let item of items;let i = index">
          <div nz-row>
            <div nz-col class="mj-content-col" nzSpan="1" nzOffset="0">
              <nz-avatar [nzSize]="64" nzIcon="user"
                [nzSrc]="'https://image.baidu.com/search/detail?ct=503316480&z=0&tn=baiduimagedetail&ipn=d&cl=2&cm=1&sc=0&lm=-1&ie=gb18030&pn=0&rn=1&di=7466852183703552001&ln=0&word=%CD%B7%CF%F1&os=1064923262,313729969&cs=2237928324,3831333781&objurl=http%3A%2F%2Fimg.rongyuejiaoyu.com%2Fuploads%2F20240728%2F02511242750.jpeg&bdtype=0&simid=2237928324,3831333781&pi=0&adpicid=0&timingneed=&spn=0&is=0,0'"></nz-avatar>
            </div>
            <div nz-col class="mj-content-col" nzSpan="18" nzOffset="0">
              <p><b>MJ AI BOT</b>&nbsp;<app-datetime [text]="item.updated_at"></app-datetime> <span
                  *ngIf="item.status == 'NOT_START'" style="margin-left:15px;">处理中...</span><span
                  *ngIf="item.status == 'WAIT'" style="margin-left:15px;">等待中...</span><span
                  *ngIf="item.status == 'FAILURE'" style="margin-left:15px;">合成失败</span></p>
              <p>{{ item.prompt}}</p>
              <img *ngIf="item.final_url" nz-image width="600" [nzSrc]="item.final_url" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="create">
        <div class="list">
          <div class="item" *ngFor="let item of createList;let i = index">
            <div class="time"><app-datetime [text]="item.updated_at"></app-datetime></div>
            <div class="info">
              <div class="icon"><img src="../../../assets/images/mj/sandyClock.png"></div>
              <div class="right">
                <div class="title">{{ item.original}}</div>
                <div class="name">创作中...</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nz-content>
  </nz-layout>

  <nz-footer>
    <div nz-row class="footer-content">
      <!-- <div nz-col nzSpan="18" nzOffset="3">
        <div id="actionBox">
          <img src="https://bandeyu-1256181000.cos.ap-chengdu.myqcloud.com/bandeyu/mj_bandeyu_com/icon/mj.gif"
            width="26" height="25" id="mjIcon" />
          <h6 id="actionTitle">
            AI绘画【aihuihua.com】
            <a onclick="return setAction(this.className)" class="imagine" style="
                      float: right;
                      display: inline-block;
                      margin-top: -10px;
                      margin-right: 5px;
                      font-size: 20px;
                    " href="#">x</a>
          </h6>
          <ul>
            <li onclick="return setAction(this.className)" class="imagine">
              <img src="https://bandeyu-1256181000.cos.ap-chengdu.myqcloud.com/bandeyu/mj_bandeyu_com/icon/1.png"
                width="26" height="25" />MJ AI /imagine（文生图）<span class="zh">MJ AI绘画的文生图，输入提示词、垫图、调整参数</span>
            </li>
            <li class="changeBackground">
              <a href="/getAi/changeBackground/?src=action"><img
                  src="https://bandeyu-1256181000.cos.ap-chengdu.myqcloud.com/bandeyu/mj_bandeyu_com/icon/4.png"
                  width="26" height="25" />产品换背景 /changeBackground<strong
                  style="color: #ffff00; font-weight: normal; font-size: 12px"></strong><span
                  class="zh">更换商品（产品）背景，例如美妆产品、家电……等</span></a>
            </li>
            <li onclick="return setAction(this.className)" class="blend">
              <img src="https://bandeyu-1256181000.cos.ap-chengdu.myqcloud.com/bandeyu/mj_bandeyu_com/icon/7.png"
                width="26" height="25" />混合图 /blend<span class="zh">MJ AI绘画将多张图像混合在一起重新生成新图</span>
            </li>
            <li class="lineToImg">
              <a href="/getAi/lineToImg/?src=action"><img
                  src="https://bandeyu-1256181000.cos.ap-chengdu.myqcloud.com/bandeyu/mj_bandeyu_com/icon/8.png"
                  width="26" height="25" />线搞转绘 /lineToImg<strong
                  style="color: #ffff00; font-weight: normal; font-size: 12px"></strong><span
                  class="zh">黑白线稿图片，绘制成颜色丰富的各类图</span></a>
            </li>
            <li onclick="return setAction(this.className)" class="describe">
              <img src="https://bandeyu-1256181000.cos.ap-chengdu.myqcloud.com/bandeyu/mj_bandeyu_com/icon/2.png"
                width="26" height="25" />图生文 /describe<span class="zh">MJ AI图生文，基于你的图片识别出大致的指令</span>
            </li>
            <li class="swapFace">
              <a href="/getAi/swapFace/?src=action"><img
                  src="https://bandeyu-1256181000.cos.ap-chengdu.myqcloud.com/bandeyu/mj_bandeyu_com/icon/5.png"
                  width="26" height="25" />换脸（单人）/swapFace<strong
                  style="color: #ffff00; font-weight: normal; font-size: 12px"></strong><span
                  class="zh">单人换脸，暂不支持多人换脸、不支持动物和壁画类人物换脸</span></a>
            </li>
            <li onclick="return setAction(this.className)" class="RemoveBG">
              <img src="https://bandeyu-1256181000.cos.ap-chengdu.myqcloud.com/bandeyu/mj_bandeyu_com/icon/3.png"
                width="26" height="25" />自动抠图 /removeBackground<span class="zh">自动去除图片的背景，生成透明背景的图片</span>
            </li>
            <li class="faceStyle">
              <a href="/getAi/faceStyle/?src=action"><img
                  src="https://bandeyu-1256181000.cos.ap-chengdu.myqcloud.com/bandeyu/mj_bandeyu_com/icon/5.png"
                  width="26" height="25" />人物换风格（单人）/faceStyle<strong
                  style="color: #ffff00; font-weight: normal; font-size: 12px"></strong><span
                  class="zh">单个人物的照片，更换不同的风格</span></a>
            </li>
            <li onclick="return setAction(this.className)" class="BigScale">
              <img src="https://bandeyu-1256181000.cos.ap-chengdu.myqcloud.com/bandeyu/mj_bandeyu_com/icon/6.png"
                width="26" height="25" />无损放大 /bigScale<span class="zh">2倍无损放大原图片</span>
            </li>
            <li class="faceAlike">
              <a href="/getAi/faceAlike/?src=action"><img
                  src="https://bandeyu-1256181000.cos.ap-chengdu.myqcloud.com/bandeyu/mj_bandeyu_com/icon/5.png"
                  width="26" height="25" />个人写真（换背景、换姿势）/faceAlike<strong
                  style="color: #ffff00; font-weight: normal; font-size: 12px"></strong><span
                  class="zh">有正脸单人照片，就可以更换不同的姿势、所在场景等</span></a>
            </li>
            <li class="region">
              <a href="/getAi/region/?src=action"><img
                  src="https://bandeyu-1256181000.cos.ap-chengdu.myqcloud.com/bandeyu/mj_bandeyu_com/icon/4.png"
                  width="26" height="25" />局部重绘 /region<strong
                  style="color: #ffff00; font-weight: normal; font-size: 12px"></strong><span
                  class="zh">把已有的图片的部分区域重新绘制</span></a>
            </li>
            <li onclick="return setAction(this.className)" class="flux">
              <img src="https://bandeyu-1256181000.cos.ap-chengdu.myqcloud.com/bandeyu/mj_bandeyu_com/icon/1.png"
                width="26" height="25" />Flux /文生图<span class="zh">基于Flux模型的文生图模型，媲美MJ</span>
            </li>
            <li class="expand">
              <a href="/getAi/expand/?src=action"><img
                  src="https://bandeyu-1256181000.cos.ap-chengdu.myqcloud.com/bandeyu/mj_bandeyu_com/icon/8.png"
                  width="26" height="25" />扩展图片 /expand<strong
                  style="color: #ffff00; font-weight: normal; font-size: 12px"></strong><span
                  class="zh">基于原图向外绘制更大的图片</span></a>
            </li>
            <li onclick="return setAction(this.className)" class="ideogram">
              <img src="https://bandeyu-1256181000.cos.ap-chengdu.myqcloud.com/bandeyu/mj_bandeyu_com/icon/1.png"
                width="26" height="25" />Ideogram /文生图<span class="zh">Ideogram AI文生图，擅长英文艺术字，每次出1张图</span>
            </li>
          </ul>
        </div>
      </div> -->
      <div nz-col nzSpan="18" nzOffset="3" *ngIf="!mjloading">
        <div nz-row>
          <div nz-col nzSpan="2" class="footer-content-col-1" *ngIf="mjInfo.rd">
            <div class="thumb">
              <img *ngIf="mjInfo.rd" nz-image width="60" height="80" [nzSrc]="mjInfo.rd" alt="" />
            </div>
          </div>
          <div nz-col nzSpan="20" class="footer-content-col-1">
            <div nz-row style="height: 30px;">
              <div nz-col class="footer-content-col-2" nzSpan="20">
                <div class="flex">
                  <div class="ability">
                    <p>MJ AI/imagine (文生图) <img
                        src="https://bandeyu-1256181000.cos.ap-chengdu.myqcloud.com/bandeyu/mj_bandeyu_com/icon/change.gif?4"
                        width="14" height="14"><span nz-button nzType="primary" nz-popover
                        [(nzPopoverVisible)]="visible" (nzPopoverVisibleChange)="change($event)"
                        nzPopoverTrigger="click" [nzPopoverContent]="contentTemplate"> 切换功能</span>
                      <ng-template #contentTemplate>
                        <ul class="modeselect">
                          <li [class]="model == 'FAST'?'active fast':''"  (click)="changeMode('FAST')">fast模式（快速）</li>
                          <li [class]="model == 'RELAX'?'active relax':''"  (click)="changeMode('RELAX')">relax模式（慢速）</li>
                        </ul>
                      </ng-template>
                    </p>
                  </div>
                  <div class="upload">
                    <input type="file" accept="image/*" (change)="handleFileSelect($event)" class="inputFile" />
                    <button nz-button nzGhost nzType="default" style="background: #030303;border-radius: 4px;border:solid 1px #030303;">上传图片</button>
                  </div>
                </div>
              </div>

            </div>
            <div nz-row style="height: 30px;">
              <div nz-col class="footer-content-col-3" nzSpan="20" nzOffset="0">
                <input nz-input [(ngModel)]="mjInfo.prompt" nzBorderless [nzSize]="'large'"
                  placeholder="在此描述您要绘制的图片的关键词"  (keyup.enter)="handleKeyPress()"/>
              </div>
            </div>
          </div>
          <div nz-col nzSpan="2" class="footer-content-col-1">
            <span (click)="submitMj()">绘画</span>
          </div>
        </div>
      </div>

      <div nz-col nzSpan="18" nzOffset="3" *ngIf="mjloading">
        <div nz-row>
          <div nz-col nzSpan="4" nzOffset="10">
            <img src="../../../assets/images/mj/loading.gif" alt="" width="100" height="100">
            <span style="color:#fff;">正在绘画中......{{currentObj.progress}}</span>
          </div>
        </div>
      </div>
    </div>

  </nz-footer>
</nz-layout>